import React, { cloneElement, Children } from 'react';
import { Navigation, Ul, ToggleButton, IconToggle, Wrapper } from '../style';
import { useSideBar } from './useSidebar';
var SideBar = function (_a) {
    var _b = _a.positionToggle, positionToggle = _b === void 0 ? 'calc(50% - 20px)' : _b, _c = _a.primary, primary = _c === void 0 ? 'rgb(21, 3, 68)' : _c, _d = _a.secondary, secondary = _d === void 0 ? 'white' : _d, hideToggleButton = _a.hideToggleButton, forceIsClosed = _a.forceIsClosed, forceIsOpen = _a.forceIsOpen, isOpenBydefault = _a.isOpenBydefault, onIsOpenChange = _a.onIsOpenChange, children = _a.children;
    var _e = useSideBar({
        isOpenBydefault: isOpenBydefault,
        onIsOpenChange: onIsOpenChange,
        forceIsClosed: forceIsClosed,
        forceIsOpen: forceIsOpen,
        hideToggleButton: hideToggleButton,
    }), handleToggle = _e.handleToggle, toggleActive = _e.toggleActive, activeNavigation = _e.activeNavigation, hasToggleButton = _e.hasToggleButton;
    return (React.createElement(Wrapper, { active: toggleActive },
        React.createElement(Navigation, { primaryColor: primary, secondaryColor: secondary, active: activeNavigation },
            React.createElement(Ul, null, Children.map(children, function (child) {
                return cloneElement(child, { primary: primary, secondary: secondary });
            }))),
        hasToggleButton && (React.createElement(ToggleButton, { active: toggleActive, onClick: handleToggle, primaryColor: primary, secondaryColor: secondary, yPositionToggle: positionToggle },
            React.createElement(IconToggle, { left: toggleActive, secondaryColor: secondary, primaryColor: primary, active: toggleActive, className: toggleActive ? 'active' : '' },
                React.createElement("span", null),
                React.createElement("span", null))))));
};
export default SideBar;
